var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { isNullOrEmpty } from '@pcty/utils';
/**
 * Searches employee data
 *
 * @category Search
 * @param {array} data - The full dataset of employees
 * @param {string} search - The search text - case-insensitive
 * @param {object} [keys=[['firstName', 'lastName'], 'position']] - The keys in your employee data set to search against. You can search a combined keys by adding child arrays of keys to combine. Case-sensitive
 * @returns {array} - The employees that match the search criteria
 */
export default (function (data, search, keys) {
    if (keys === void 0) { keys = [['firstName', 'lastName'], 'position']; }
    if (isNullOrEmpty(data))
        return [];
    if (isNullOrEmpty(search))
        return data;
    search = search.toLowerCase();
    return data.reduce(function (accumulator, x) {
        for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
            var key = keys_1[_i];
            var searchAgainst = '';
            if (typeof key === 'string') {
                searchAgainst = isNullOrEmpty(x[key.trim()]) ? '' : x[key.trim()].toString().toLowerCase();
            }
            else {
                searchAgainst = key
                    .map(function (s) { return (isNullOrEmpty(x[s.trim()]) ? '' : x[s.trim()].toString().toLowerCase()); })
                    .filter(function (s) { return s.length > 0; })
                    .join(' ');
            }
            if (searchAgainst.indexOf(search) >= 0) {
                return __spreadArray(__spreadArray([], accumulator, true), [x], false);
            }
        }
        return accumulator;
    }, []);
});
